import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateCategoryTypeV3 = OpalApi<'CreateCategoryTypeV3', 201>

export const createCategoryType: CreateCategoryTypeV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/category_types/', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
